// extracted by mini-css-extract-plugin
export default {"addPictureButton":"jtfQJmgdsOwVKGzJotPh","hiddenInput":"zUu1HmJ5FDDIeOISWnQQ"};